<template>
  <div class="agence-container">
    <FraisTransportTranches
      v-if="agence.tranches"
      :tranches="agence.tranches"
      @deleteForfait="deleteForfait"
      @updateForfait="updateForfait"
    />
    <div
      v-for="(zone, zoneKey) of agence.zones"
      :key="'zone' + zoneKey"
    >
      <p class="forfait__zone flex-fJstart-fAcenter">
        <Icon
          name="hexagon"
        />
        <span>{{ zone.label }}</span>
      </p>
      <div class="zone-container">
        <template>
          <FraisTransportTranches
            v-if="zone.tranches"
            :tranches="zone.tranches"
            :display-title="categoriesOptions != null && categoriesOptions.length > 0"
            @deleteForfait="deleteForfait"
            @updateForfait="updateForfait"
          />
        </template>
        <template
          v-for="(categorie, categorieKey) of zone.categories"
        >
          <FraisTransportTranches
            :key="'category' + categorieKey"
            :tranches="categorie.tranches"
            :title="categorie.label"
            @deleteForfait="deleteForfait"
            @updateForfait="updateForfait"
          />
        </template><!-- end of categorie-container -->
      </div><!-- end of zone loop -->
    </div><!-- end of zone-container -->
  </div><!-- end of agence-container -->
</template>

<script>
import Icon from './Icon'
import FraisTransportTranches from './FraisTransportTranches.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Icon,
    FraisTransportTranches
  },
  props: {
    agence: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'categoriesOptions'
    ])
  },
  methods: {
    deleteForfait(forfaitId) {
      this.$store.dispatch('deleteForfaitTransport', forfaitId)
    },
    updateForfait(forfait) {
      this.$store.dispatch('updateForfaitTransport', forfait)
    }
  }
}
</script>

<style lang="postcss" scoped>
.zone-container {
  padding-left: 20px;
}

.agence-container {
  padding-left: 24px;
  border-top: 1px solid #cdcdcd;
}
</style>
